import DeleteIcon from "@mui/icons-material/Delete";
import {
  Button,
  Dialog,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import {
  bindPopover,
  bindTrigger,
  usePopupState,
} from "material-ui-popup-state/hooks";
import { useId } from "react";
import {useDeleteAuthToken} from "../../benutzer";

export default function AuthTokenDeleteButton({
  tokenType,
}: {
  tokenType: string;
}) {
  const { mutate } = useDeleteAuthToken(tokenType);
  const popupState = usePopupState({ variant: "popover", popupId: useId() });

  return (
    <>
      <IconButton {...bindTrigger(popupState)}>
        <DeleteIcon />
      </IconButton>
      <Dialog {...bindPopover(popupState)}>
        <DialogTitle id="alert-dialog-title">
          Authtoken wirklich löschen?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Sie sind dabei diesen Token zu löschen. Sind Sie sich sicher?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={popupState.close} color="inherit">
            Abbrechen
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              mutate();
              popupState.close();
            }}
          >
            Löschen
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
